import React from 'react';
import axios from 'axios';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';
import { Button, Modal, Row, Col } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';

import { url } from '../../constants/routes';
import './styles.css';
import Navigation from '../../components/Navigation';
import Footer from '../../components/Footer';
import LocalStorage from '../../components/LocalStorage/index';
import TextHero from '../../components/TextBanner';
import {
  connect as reduxConnect,
  actions as allActions
} from '../../reducers/index';
import MonitorGraphic from './img/website-on-monitor@3x.png';

class ThankYouPage extends React.Component {
  constructor(props) {
    super(props);

	this.isShowPromo = this.isShowPromo.bind(this);
    this.changeName = this.changeName.bind(this);
    this.clickSubmit = this.clickSubmit.bind(this);
	this.changePromoName = this.changePromoName.bind(this);
	this.changePromoEmail = this.changePromoEmail.bind(this);
	this.handlePromoSubmit = this.handlePromoSubmit.bind(this);

    this.state = {
      name						: '',
      role						: LocalStorage.getRole() || 'NONE',
      campus					: LocalStorage.getCampus() || 'NONE',
	  promoName					: '',
	  promoEmail				: '',
	  promoInfoSaveSucces		: false,
	  promoInfoSaveSuccesMsg	: '',
	  promoInfoSaveError		: false,
	  promoInfoSaveErrorMsg		: '',
	  showPromo					: this.isShowPromo()
    };

  }

  isShowPromo(){

	const estOptions = {
		timeZone: 'America/New_York',
		year: 'numeric',
		month: 'numeric',
		day: 'numeric',
		hour: 'numeric',
		minute: 'numeric',
		second: 'numeric',
	};

	// Promo should only be visible from May 1 12AM to May 31 11:59PM
	let startDateTimeEST 		= new Date(new Date('2025-05-01T00:00:00').toLocaleString('en-US', estOptions));
	let endDateTimeEST 		= new Date(new Date('2025-06-01T00:00:00').toLocaleString('en-US', estOptions));

		
	// The following code will run only on test environment
	if(window.location.origin.includes("iar-dev")){
		// Change the start date on dev for testing
		startDateTimeEST 	= new Date(new Date('2023-04-30T00:00:00').toLocaleString('en-US', estOptions));
	}

	const now = new Date(new Date().toLocaleString('en-US', estOptions));
	const isPromoTime = (now >= startDateTimeEST && now <= endDateTimeEST);
	return isPromoTime && LocalStorage.getCampus() === "UTSG" && LocalStorage.getRole() === "STUDENT";	
  }

  componentWillMount() {
    // if (!this.props.training.onTrainingCompleted) {
    //   window.location = "/main/education-module"
    // }
  }

  changeName(event) {
    this.setState( { name: event.target.value } );
  }

  clickSubmit() {
    this.props.onChangeName( this.state.name );
  }

  changePromoName(event){
    this.setState({ promoName: event.target.value });
  }

  changePromoEmail(event){
    this.setState({ promoEmail: event.target.value });
  }

  handlePromoSubmit(event) {

    event.preventDefault();

	// Hide the response messages
	this.setState({ promoInfoSaveSucces : false }); // Hide the success message
	this.setState({ promoInfoSaveSuccesMsg: ''});
	this.setState({ promoInfoSaveError : false }); // Hide the error message
	this.setState({ promoInfoSaveErrorMsg : ''});

    fetch('/promotion/save.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(this.state)
    })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
	.then(data => {
      console.log('Success:', data);
      // Handle success (e.g., display a success message, redirect)

	  if(data.status == "success"){
	    this.setState({ promoInfoSaveSucces : true });
		this.setState({ promoInfoSaveSuccesMsg : 'Thank you for participating!' });
	  }else{

		// Something's wrong

		this.setState({ promoInfoSaveError : true });

		if(data.errorType === 'db'){
			let message = `Error: The application seems to have encountered a problem. We encourage you to complete the training and contact health.promotion@utoronto.ca for support. We apologize for this inconvenience. (Error-code: DB)`;
			this.setState({ promoInfoSaveErrorMsg : message });
		}

		if(data.errorType === 'validation'){
			this.setState({ promoInfoSaveErrorMsg : data.message });
		}

	  }
    })
    .catch(error => {
      console.error('Error:', error);
      // Handle error (e.g., display an error message)
		let message = `Error: The application seems to have encountered a problem. We encourage you to complete the training and contact health.promotion@utoronto.ca for support. We apologize for this inconvenience. (Error-code: SE)`;
	  	this.setState({ promoInfoSaveError : true });
		this.setState({ promoInfoSaveErrorMsg : message });
 
    });
  }


  render() {
    const { role } = this.props;

    // if (!this.props.training.onTrainingCompleted) {
    //   window.location = "/main/education-module"
    // }

	const renderPromoForm = (
		<div className="alert alert-info" style={{ 'color':'black', 'margin':'20px' }}>
			<form onSubmit={this.handlePromoSubmit}>
				<p><span style={{ 'font-weight':'bold' }}>Enter the IAR Giveaway!</span><br/><br/>Thank you for completing Identify, Assist, Refer! Through May, UTSG students who complete IAR can submit their name and U of T email for a chance to win one of three $50 gift cards to Uber, Instacart or Amazon.  </p>
				<div class="input-group">
					<label for="promoName" className="input-group-addon" 
					style={{
						color: 'darkgreen',
						fontSize: '20px',
						'min-width': '150px'
					}}>Name:</label>
					<input type="text" id="promoName" name="name" className="form-control" value={this.state.promoName} onChange={this.changePromoName} required disabled={this.state.promoInfoSaveSucces} />
				</div>
				<br />
				<div class="input-group">
					<label for="promoEmail" className="input-group-addon"
					style={{
						color: 'darkgreen',
						fontSize: '20px',
						'min-width': '150px'
					}}>U of T email:</label>
					<input type="email" id="promoEmail" name="email" className="form-control" value={this.state.promoEmail} onChange={this.changePromoEmail} required disabled={this.state.promoInfoSaveSucces} />
				</div>
				<p><strong>Note</strong>: Your name and email will not be linked to your feedback survey responses and are only being collected for the purpose of this giveaway. Only U of T, St. George, students are eligible for this giveaway. </p>
				
				<p>IAR Giveaway Rules: <a target="_blank" href="https://studentlife.utoronto.ca/identify-assist-refer-giveaway/">https://studentlife.utoronto.ca/identify-assist-refer-giveaway/</a>a</p>
				<br />
				<button className="btn btn-blue" type="submit" disabled={this.state.promoInfoSaveSucces}>Submit</button>
				{
				  this.state.promoInfoSaveSucces
				  &&	
				  <div>
					  <br/>
					  <div className="alert alert-success" style={{ 'font-weight':'bold' }}>{ this.state.promoInfoSaveSuccesMsg }</div>
				  </div>
				}
				{
				  this.state.promoInfoSaveError
				  &&	
				  <div>
					  <br/>
					  <div className="alert alert-danger">{ this.state.promoInfoSaveErrorMsg }</div>
				  </div>
				}
			</form>
		</div>
	);

    const renderContactForm = (
      <form className="contact-form" onKeyDown={(event) => { return event.key !== 'Enter'; }}>
        <Row className="text-center">
          <h3 className="no-bold txt-ltblue">
            To finish and obtain your certificate, please fill in these fields:
          </h3>
          <Col xs={12}>
            <label htmlFor="contact-form-name">
              <h4>Name as you would like it to appear on the certificate</h4>
            </label>
            <input
              type="text"
              id="contact-form-name"
              required={true}
              value={this.state.name}
              onChange={this.changeName}
            />
            <br />
          </Col>
          <Col xs={12} style={{ marginTop: 10 }}>
            <LinkContainer to={url.CERTIFICATE} onClick={this.clickSubmit} className="btn btn-blue next">
              <Button>Next</Button>
            </LinkContainer>
          </Col>
        </Row>
        <Row className="text-center">
          <Col xsOffset={1} xs={10}>
            <LinkContainer to={url.MODULE}>
              <p><a>Return Home</a></p>
            </LinkContainer>
            <p>
              <small>
                * The Certificate of Completion denotes successful completion of
                Identify, Assist, Refer and should not be interpreted as a recognized
                certificate from the University of Toronto.
              </small>
            </p>
          </Col>
        </Row>
      </form>
    );

    return (
      <div className="education-module thank-you">
        <Helmet>
          <title>Certificate of Completion</title>
        </Helmet>
        <Navigation role={role} />
        <TextHero childTitle={'Thank you!'} />

        <section
          style={{
            marginTop: '-100px'
          }}
        >
          <div className="container text-center">
            <Row>
              <Col xsOffset={1} xs={10}>
                <h2>
                  By learning how to Identify, Assist, Refer someone
                  experiencing a mental health challenge, you’re helping to create a 
                  culture of care at UofT.
                </h2>
                <p>
                  Re-access this training at any time! Quickly access resources or summary 
                  of training by visiting the Resources and Quick Guide links found in the upper right tabs.  
                </p>
                <p>
                  Lastly, as you put your <strong>“Identify, Assist, Refer”</strong> skills to use,
                  remember that supporting others can be difficult. Please take
                  the time and space needed to take care of yourself, seek
                  out support, and ask for help from those around you.
                </p>
              </Col>
            </Row>
            <Row>
              <Col mdOffset={1} md={10} xs={12}>
                {
					this.state.showPromo
					&& 	
					renderPromoForm
				}
              </Col>
            </Row>
            <Row>
              <Col mdOffset={1} md={10} xs={12}>
                {renderContactForm}
              </Col>
            </Row>
          </div>
        </section>
        <section className="bg-ltblue bg-report">
          <div className="container">
            <Row>
              <Col xs={12} sm={6}>
                <img
                  className="img-block img-responsive"
                  src={MonitorGraphic}
                  width="410"
                  alt="Monitor with website on screen"
                />
              </Col>
              <Col xs={12} sm={6}>
                <h3 className="no-bold txt-ltblue">
                  Access Mental Health Framework Report
                </h3>
                <p>
                  Introducing a perspective on student mental wellness that
                  includes everyone.
                </p>
                <br />
                <p>
                  <Button
                    className="btn btn-blue next"
                    style={{ width: '200px' }}
                    target="_blank"
                    rel="noopener noreferrer"
                    href="http://mentalhealth.utoronto.ca/sites/default/files/Report%20on%20Student%20Mental%20Health%202014.pdf"
                  >
                    Download report
                  </Button>
                </p>
                <p>
                  <Button
                    target="_blank"
                    style={{ width: '200px' }}
                    rel="noopener noreferrer"
                    className="btn btn-blue next"
                    href="http://mentalhealth.utoronto.ca/"
                  >
                    Visit website
                  </Button>
                </p>
              </Col>
            </Row>
          </div>
        </section>
        <Footer />
      </div>
    );
  }
}

ThankYouPage.propTypes = {
  role: PropTypes.object.isRequired // eslint-disable-line react/forbid-prop-types
};

ThankYouPage.defaultProps = {
  role: {}
};

ThankYouPage.contextTypes = {
  router: PropTypes.object.isRequired
};

const ThankYou = ThankYouPage;

export default reduxConnect.training(reduxConnect.contact(reduxConnect.role(ThankYou)));



// WEBPACK FOOTER //
// ./src/containers/ThankYou/index.jsx